import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Popover, Box } from "@mui/material";
import Calendar from "react-calendar";
import useStyles from "./styles";
import moment from "moment";

const DateRangePicker = ({ dateRange, onChangeDateRange }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <Box>
      <Box>
        <span className={classes.periodText}>
          {t("purchase_screen.period")}
        </span>
      </Box>
      <Box mt={1.5} onClick={(e) => setAnchorEl(e.currentTarget)}>
        <span className={classes.dateRangeText}>{`${moment(dateRange[0]).format(
          "DD MMM"
        )} - ${moment(dateRange[1]).format("DD MMM")}`}</span>
      </Box>

      <Popover
        id={"date-range"}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Calendar
          value={dateRange}
          onChange={(value) => {
            onChangeDateRange(value);
            setAnchorEl(null);
          }}
          showDoubleView
          selectRange
          maxDate={new Date()}
        />
      </Popover>
    </Box>
  );
};

export default DateRangePicker;
